import { addBreadcrumb } from '@sentry/react';
import { useEffect } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { useAsset } from '@ocx-app/modules/configuration/use-asset.hook';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useConfiguration } from '@ocx-app/modules/configuration/useConfiguration';

import { PointsStrategy } from './loyalty-currency.types';

type Size = 'small' | 'medium' | 'large';

const sizeMap: Record<Size, number> = {
  small: 16,
  medium: 24,
  large: 32,
};

type LoyaltyCurrencyIconProps = {
  variant?: 'single' | 'multiple';
  size?: Size;
};

export const LoyaltyCurrencyIcon = (props: LoyaltyCurrencyIconProps) => {
  const { variant = 'single', size = 'medium' } = props;

  const config = useConfiguration<'loyaltyCurrency'>('loyaltyCurrency');

  const iconKey = config.iconConfig?.[variant] ?? 'CoinIcon';
  const iconSrc = useAsset(iconKey);

  useEffect(() => {
    if (config.pointsStrategy === PointsStrategy.NotUsed) {
      addBreadcrumb({ message: 'PointsStrategy.NotUsed encountered in LoyaltyCurrencyIcon or missing config' });
    }
  }, [config]);

  if (config.pointsStrategy === PointsStrategy.NotUsed || !config.iconConfig || !iconSrc) {
    return null;
  }

  return <img src={iconSrc} alt="coins" width={sizeMap[size]} height={sizeMap[size]} />;
};
